const backgroundBlendMode = {
    name: "background-blend-mode",
    path: "background-blend-mode",
    title: "background-blend-mode",
    description: "Utilities for controlling the CSS background-blend-mode property.",
    value: {
        "background-blend-mode": {
            "bg-blend-normal": "normal",
            "bg-blend-multiply": "multiply",
            "bg-blend-screen": "screen",
            "bg-blend-overlay": "overlay",
            "bg-blend-darken": "darken",
            "bg-blend-lighten": "lighten",
            "bg-blend-color-dodge": "color-dodge",
            "bg-blend-color-burn": "color-burn",
            "bg-blend-hard-light": "hard-light",
            "bg-blend-soft-light": "soft-light",
            "bg-blend-difference": "difference",
            "bg-blend-exclusion": "exclusion",
            "bg-blend-hue": "hue",
            "bg-blend-saturation": "saturation",
            "bg-blend-color": "color",
            "bg-blend-luminosity": "luminosity"
        }
    },
    exampleData: [
        {
            title: "bg-blend-multiply, bg-blend-screen",
            description: "Apply different background blend modes to overlapping backgrounds:",
            example: {
                code: `<div class="bg-color-blue-500 bg-blend-multiply bg-image-[url(...)]"></div>
<div class="bg-color-blue-500 bg-blend-screen bg-image-[url(...)]"></div>
<div class="bg-color-blue-500 bg-blend-overlay bg-image-[url(...)]"></div>`
            }
        }
    ],
    htmlData: [
        {
            title: "Background blend mode",
            data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">bg-blend-*</code> utilities to control the background-blend-mode of an element.
      </p>
      <div class="flex gap-8 items-center">
        <div class="w-64 bg-cover h-32 bg-color-blue-500 bg-blend-multiply bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] rounded"></div>
        <div class="w-64 bg-cover h-32 bg-color-blue-500 bg-blend-screen bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] rounded"></div>
        <div class="w-64 bg-cover h-32 bg-color-blue-500 bg-blend-overlay bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] rounded"></div>
      </div>
      `
        }
    ]
};

export default backgroundBlendMode;
<div className="sr-only bg-blend-multiply bg-blend-screen bg-blend-overlay"></div>